/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Reports/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import React from 'react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import styles from './view.module.css'
let Report = React.lazy(() => import('./Report/index'))
let ReportList = React.lazy(() => import('./ReportList/index'))
let StockReport = React.lazy(() => import('./StockReport/index'))



/** @type {import('Simple/types.js').View} */
export default function Reports({
  children,
  viewPath = "/App/Account/Content/Reports"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'ReportList'
let tabTabValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'tab',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: tabTabValueData,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="Reports.Vertical"
  data-view-path={viewPath}
 style={{'--bblr-1-Z1NTNxa': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-2-Z1NTNxa': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-3-Z1NTNxa': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-Z1NTNxa': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-Z1NTNxa': dtColorsWhite,'--bc-6-Z1NTNxa': dtColorsNeutral400}}
 className={`views-block ${styles.Vertical}`}
>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={flowValue === 'ReportList'}>
<ReportList
{...childProps}
  viewPath={`${viewPath}/ReportList`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Report'}>
<Report
{...childProps}
  viewPath={`${viewPath}/Report`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'StockReport'}>
<StockReport
{...childProps}
  viewPath={`${viewPath}/StockReport`}
/>
</fromFlow.When>
</React.Fragment>
)}
</SuspenseBoundary>
</div>
{children}
</React.Fragment>)
}